import { Icon } from '@/components/foundations';
import { BarChart } from '@/components/charts';
import { DataTable, Panel } from '@/components/data';
import { formatBRL } from '@/components/foundations/Amount';
import { INSTALLMENT_COLUMNS, InstallmentRow, type InstallmentPurchase } from './InstallmentRow';

export type InstallmentTimelineProps = {
  /** Valor comprometido em parcelas por mês: `[rótulo, valor]`. */
  months: readonly (readonly [string, number])[];
  purchases: readonly InstallmentPurchase[];
  /** Filtro de cartão do cabeçalho do gráfico. */
  cardFilter?: string;
};

/** Comprometido por mês (barras) + compras parceladas ativas (tabela). */
export function InstallmentTimeline({ months, purchases, cardFilter = 'Todos os cartões' }: InstallmentTimelineProps) {
  return (
    <>
      <Panel as="section" title="Comprometido por mês" style={{ marginBottom: 16 }} action={<label className="dropdown sm">{cardFilter}<Icon name="down" /></label>}>
        <BarChart label="Valor comprometido em parcelas por mês" data={months.map(([label, value]) => ({ label, value }))} format={(v) => formatBRL(v).replace('R$ ', '')} />
      </Panel>
      <Panel as="section" variant="recent" head="bar" title="Compras parceladas ativas">
        <DataTable
          rows={purchases}
          rowKey={(p) => p.name}
          columns={INSTALLMENT_COLUMNS}
          renderRow={(p) => <InstallmentRow purchase={p} />}
          empty={<p style={{ color: 'var(--muted)', padding: '6px 0' }}>Nenhuma compra parcelada ativa.</p>}
        />
      </Panel>
    </>
  );
}
